<template>
  <div class="region-switch">
    <b-dropdown variant="link"
                toggle-class="text-decoration-none"
                no-caret>
      <template #button-content>
        <div class="region-switch__icon-container">
          <i class="fas fa-globe"></i>
          <span v-if="currentRegion"
                class="region-switch__icon-label">
            {{ currentRegion.label }}
          </span>
          <i class="fas fa-long-arrow-down"></i>
          <span class="sr-only">
            Switch Country
            <span v-if="currentRegion"> - {{ currentRegion.label }} is currently selected.</span>
          </span>
        </div>
      </template>
      <b-dropdown-item v-for="( region, index ) in filteredRegions"
                       :key="`${index}-${region.id}`"
                       :aria-labelledby="region.id"
                       :href="region.url">
        {{ region.label }}
        <span v-if="region && region.seoLinkDescription"
              :id="region.id"
              class="sr-only">
          - {{ region.seoLinkDescription }}
        </span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
export default {
  name: "RegionSwitch",
  props: {
    excludeCurrentRegion: {
      type: Boolean,
      default: false,
    },
    currentRegionId: {
      type: String,
      default: undefined,
    },
    regions: {
      type: Array,
      default: () => [],
      validator: ( val ) => Array.isArray( val )
        && val.every( obj => ["id", "label", "url", "seoLinkDescription"].every( key => Object.keys( obj ).includes( key ) ) ),
    },
  },
  computed: {
    currentRegion () {
      let result;

      if ( Array.isArray( this.regions ) && this.regions.length ) {
        let currentRegion = null;
        const definedCurrentRegion = this.regions.find( r => r.id === this.currentRegionId );

        if ( definedCurrentRegion ) {
          currentRegion = definedCurrentRegion;
        } else {
          const [first] = this.regions;
          currentRegion = first;
        }

        result = currentRegion;
      }
      return result;
    },
    filteredRegions () {
      let result = this.regions || [];

      if ( Array.isArray( this.regions ) && this.regions.length && this.excludeCurrentRegion ) {
        result = this.regions.filter( region => region.id !== this.currentRegionId );
      }
      return result;
    },
  },
};
</script>
<style lang="less">
.region-switch {
  display: flex;
  margin-right: 30px;

  @media ( max-width: 991px ) {
    padding: 10px 20px;
    font-size: 0.8rem;
    background: #f2f2f2;
    border-bottom: 1px solid #ccc;
    margin-right: 0 !important;
  }

  &__icon-label {
    font-weight: 400;

    @media ( max-width: 991px ) {
      font-weight: 600;
    }
  }

  &__icon-label, .fa-long-arrow-down {
    font-size: 0.8rem;
  }

  &__icon-container {
    .fa-globe {
      color: #D71920;
    }

    > * {
      transition: color 0.2s ease-out;
      color: #000;
    }
    &:hover {
      * {
        color: #D71920;
      }
    }

    @media ( max-width: 991px ) {
      .region-switch__icon-label {
        margin-left: 0.5rem;
        color: #000;
      }

      .fa-long-arrow-down {
        color: #000;
      }

      > * {
        color: #D71920;
      }
      &:hover {
        * {
          color: #D71920;
        }
      }
    }
  }

  > .dropdown {
    > button {
      padding: 0;
    }
  }

  ul {
    li {
      a {
        text-decoration: none;

        &:hover {
          color: #D71920;
        }
        &:active {
          color: #fff;
          background-color: #434343;
        }
      }
    }
  }
}
</style>
